module.exports = __webpack_public_path__ + "static/media/UB 1915 dominik.klaster budova konventu z ul.Mikolase Alse foto Ruzicka Vilib.58d3ba52.jpg";